import LoggedInUser from './LoggedInUser';
import Helpers from './Helpers';


export function sf_revenues() {
  return fetch(Helpers.endpoint("/revenue_breakdown?auth_token=" + LoggedInUser.getInfo().auth_token), {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }).then((response) => response.json())
}

export function funnel_kpis(dateRanges) {
  return fetch(Helpers.endpoint("/funnel_kpis"), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      date_ranges: dateRanges,
      auth_token: LoggedInUser.getInfo().auth_token, 
    })
  }).then((response) => response.json())
}

export function funnel_kpi(dateRange, kpiId) {
  return fetch(Helpers.endpoint("/funnel_kpi"), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      date_range: dateRange,
      kpi_id: kpiId,
      auth_token: LoggedInUser.getInfo().auth_token, 
    })
  }).then((response) => response.json())
}

